import { render } from "./PaymentOverview.vue?vue&type=template&id=8bad712e&scoped=true"
import script from "./PaymentOverview.vue?vue&type=script&lang=js"
export * from "./PaymentOverview.vue?vue&type=script&lang=js"

import "./PaymentOverview.vue?vue&type=style&index=0&id=8bad712e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bad712e"]])

export default __exports__